





































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSformTable from '@/components/AMSformTable.vue';
import request from '@/utils/request';
import Utils from '@/utils/utils';
import AMSDialog from '../../../components/AMSDialog.vue';
import { allStaff } from '@/api/staff';
import { deleteInstock } from '@/api/stock';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import { getModuleName } from '@/utils/utils';
import moment from 'moment';
interface Form {
  number?: string;
  stockType?: '' | 'Purchase' | 'Profit' | ' Return' | ' Transfer' | ' Other';
  stockBeginTime?: String;
  stockEndTime?: String;
  sorting?: string;
  status?: string;
  operatorId?: string;
  category?: 'In';
  productFilter?: string;
}

@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-dialog': AMSDialog,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class StockDetail extends Vue {
  breadcrumbsItems = [
    {
      text: '库存管理',
      disabled: false,
      href: 'inStock'
    },
    {
      text: '入库单',
      disabled: true
    }
  ];
  api: string = '/api/Stock/List';
  lastTime = '';
  startTime = '';
  form: Form = { category: 'In' };
  initForm() {
    this.form = { stockType: '', category: 'In', productFilter: '' };
    this.lastTime =''
    this.startTime =''
  }
  rules = {
    number: []
  };
  stockTypeList = [
    { value: '', text: '全部' },
    { value: 'Purchase', text: '采购入库' },
    { value: 'Profit', text: '盘盈入库' },
    { value: 'Return', text: '退货入库' },
    { value: 'Transfer', text: '调拨入库' },
    { value: 'Other', text: '其他入库' }
  ];
  BeginTime = false;
  EndTime = false;
  date = new Date().toISOString().substr(0, 10);
  staffList: Array<object> = [];
  statusList = [{ value: '', text: '全部' }, { value: 'Pending', text: '待审核' }, { value: 'Stocked', text: '已入库' }];

  headers = [
    { text: '单据号', value: 'number', sortable: false, width: 180, align: 'left' },
    {
      text: '入库类型',
      value: 'type',
      sortable: false,
      render: (h: Function, param: any) => {
        return h('div', this.switchType(param.row[param.keyName]));
      },
      width: 120,
      align: 'left'
    },
    { text: '数量', value: 'quantity', sortable: false, width: 80, align: 'right' },
    { text: '经办人', value: 'operator', sortable: false, width: 150, align: 'left' },
    { text: '入库时间', value: 'stockTime', isFormatDate: true, sortable: false, width: 150, align: 'left' },
    {
      text: '状态',
      value: 'status',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        return h(
          'div',
          {
            style: {
              color: this.switchStatus(param.row[param.keyName])!.color
            },
            class: {
              status: true
            },
            attrs: {
              'status-color': ''
            }
          },
          this.switchStatus(param.row[param.keyName])!.text
        );
      },
      width: 100
    },
    {
      text: '操作',
      value: 'actions',
      align: 'center',
      sortable: false,
      isDetail: [
        {
          routerName: 'inStock_detail',
          text: '查看',
          color: '#1ABC9C',
          query: { isDetail: true }
        },
        {
          routerName: 'inStock_edit',
          text: '修改',
          color: '#1ABC9C',
          query: { isEdit: true },
          isShowBtn: (row: any) => {
            return row.status !== 'Stocked' && Utils.isPermission('InventoryManager.StockInOrder.CreateOrEdit');
          }
        },
        {
          routerName: 'inStock_approve',
          text: '审核',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.status !== 'Stocked' && Utils.isPermission('InventoryManager.StockInOrder.Approve');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.deleteStock(row.item.id);
          },
          text: '删除',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.status !== 'Stocked' && Utils.isPermission('InventoryManager.StockInOrder.Delete');
          }
        }
      ],
      width: 200
    }
  ];
  deleteDialog: boolean = false;
  requestLoading: boolean = false;
  deleteItemId: string = '';

  onEnter() {
    this.$refs.BeginTimeText && (this.$refs.BeginTimeText as any).blur();
    this.$refs.EndTimeText && (this.$refs.EndTimeText as any).blur();
  }
 @Watch('lastTime', { immediate: true, deep: true })
  onStartTimeStrChange(newValue: string, oldValue: string) {
    this.form.stockEndTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('startTime', { immediate: true, deep: true })
  onEndTimeStrChange(newValue: string, oldValue: string) {
    this.form.stockBeginTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('BeginTime', { immediate: true, deep: true })
  onBeginTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.BeginTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }
  @Watch('EndTime', { immediate: true, deep: true })
  onEndTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.EndTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }
  onOperatorIdClear() {
    setTimeout(() => {
      this.form.operatorId = '';
    }, 1);
  }
  onStatusClear() {
    setTimeout(() => {
      this.form.status = '';
    }, 1);
  }
  onStockTypeClear() {
    setTimeout(() => {
      this.form.stockType = '';
    }, 1);
  }

  get minDate() {
    return this.form.stockBeginTime;
  }
  get maxDate() {
    return this.form.stockEndTime;
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  created() {
    this.getStaff();
    this.initForm();
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
       this.startTime = this.form.stockBeginTime?moment(this.form.stockBeginTime as string).format('YYYY-MM-DD'):'';
      this.lastTime = this.form.stockEndTime?moment(this.form.stockEndTime as string).format('YYYY-MM-DD'):'';
    }
  }

  getStaff() {
    allStaff({ isActive: true }).then((data: any) => {
      this.staffList = [{ value: '', text: '全部' }].concat(
        data.items.map((i: any) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }
  addStock() {
    this.$router.push({
      name: 'inStock_create'
    });
  }
  deleteStock(id: string) {
    this.deleteDialog = true;
    this.deleteItemId = id;
  }
  deleteSure() {
    this.requestLoading = true;
    deleteInstock(this.deleteItemId)
      .then((data: any) => {
        (this.$refs['formtable'] as HTMLFormElement).query();

        this.deleteDialog = false;
        this.deleteItemId = '';
      })
      .finally(() => {
        this.requestLoading = false;
      });
  }
  deleteCancel() {
    this.deleteDialog = false;
    this.deleteItemId = '';
    this.requestLoading = false;
  }
  switchType(type: string) {
    switch (type) {
      case 'Purchase':
        return '采购入库';
      case 'Profit':
        return '盘盈入库';
      case 'Return':
        return '退货入库';
      case 'Transfer':
        return '调拨入库';
      case 'Other':
        return '其他入库';
    }
  }
  switchStatus(status: string) {
    switch (status) {
      case 'Pending':
        return { color: '#FE5500', text: '待审核' };
      case 'Stocked':
        return { color: '#00A854', text: '已入库' };
    }
  }
}
